import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Invite from '@/components/BumpEgg/Invite/Invite';
import Bump from '@/components/BumpEgg/Bump/Bump';
import Result from '@/components/BumpEgg/Result/Result';
import { mapState, mapActions } from 'vuex';
import BumpAnimate from '@/components/BumpEgg/BumpAnimate/BumpAnimate';
import util from '@tencent/vft-common/util';
export var ModalType = {
  Invite: 'Invite',
  Bump: 'Bump',
  Animate: 'Animate',
  Result: 'Result',
  Share: 'Share'
};
var sessionKey = 'd2d-shareCode';
export default {
  name: 'Manager',
  components: {
    BumpAnimate: BumpAnimate,
    Result: Result,
    Bump: Bump,
    Invite: Invite
  },
  data: function data() {
    return {
      ModalType: ModalType,
      currentModal: '',
      awardInfo: null,
      awardList: [],
      isFromBump: false
    };
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isSameCode, isYourCode, showInvite;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isSameCode = this.masterShareCode && sessionStorage.getItem(sessionKey) === this.masterShareCode;
              isYourCode = this.shareCodeInfo && this.shareCodeInfo.is_your_code;

              if (!(this.masterShareCode && !isSameCode && !isYourCode)) {
                _context.next = 6;
                break;
              }

              if (this.isLogin) {
                this.startBump();
              } else {
                this._openLogin();
              }

              _context.next = 11;
              break;

            case 6:
              if (!this.isLogin) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return this.getUnReadAwardList();

            case 9:
              this.awardList = _context.sent;

              if (this.awardList.length > 0) {
                this.currentModal = ModalType.Result;
              } else {
                showInvite = util.getUrlParam('showInvite');

                if (showInvite) {
                  this.currentModal = ModalType.Invite;
                }
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  computed: _objectSpread({}, mapState('bump', ['myEggInfo', 'masterShareCode', 'shareCodeInfo'])),
  methods: _objectSpread(_objectSpread({}, mapActions('bump', ['getUnReadAwardList', 'receiveEgg'])), {}, {
    hide: function hide() {
      this.currentModal = '';
    },
    startBump: function () {
      var _startBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(this.payVip.vip || window.setting.活动逻辑.非会员可领)) {
                  _context2.next = 5;
                  break;
                }

                if (!(this.myEggInfo.is_recved !== 1)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return this.receiveEgg();

              case 5:
                this.currentModal = ModalType.Bump; // 防止页面来回跳转时重复弹出碰蛋弹窗

                if (process.env.NODE_ENV === 'production') {
                  sessionStorage.setItem(sessionKey, this.masterShareCode);
                }

                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);
                this.confirm({
                  msg: '获取碰蛋信息失败，请刷新页面重试!',
                  confirmText: '刷新',
                  confirm: function confirm() {
                    window.location.reload();
                  }
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function startBump() {
        return _startBump.apply(this, arguments);
      }

      return startBump;
    }(),
    bumpSuccess: function bumpSuccess(award) {
      this.awardInfo = award;
      this.awardList = [this.awardInfo];
      this.isFromBump = true;
      this.currentModal = ModalType.Animate;
    },
    animateSuccess: function animateSuccess() {
      this.currentModal = ModalType.Result;
    },
    share: function share(awardInfo) {
      this.awardInfo = awardInfo;
      this.currentModal = ModalType.Share;
    }
  })
};